// extracted by mini-css-extract-plugin
export default {"tabContainer":"accountActivities_tabContainer__pnq9u","dateTimeColumn":"accountActivities_dateTimeColumn__BP5kn","modalDiv":"accountActivities_modalDiv__cBMUq"};